// Track the submitting form, not the customer's marketing consent.
// Capture phase runs before ordinary theme submit handlers.
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.newsletter-form')) return;
  const contextInput = form.querySelector('input[name="contact[context]"]');
  try {
    sessionStorage.setItem('sarkastic:newsletter-pending', JSON.stringify({
      formId: form.id,
      popup: !!form.closest('newsletter-modal'),
      context: contextInput ? contextInput.value : '',
      time: Date.now()
    }));
  } catch (e) {}
}, true);

if (!customElements.get('newsletter-modal')) {
  customElements.define('newsletter-modal', class NewsletterModal extends ModalElement {
    constructor() {
      super();
      if (window.location.pathname === '/challenge' || !theme.cookiesEnabled) return;
      if (!theme.config.isTouch || Shopify.designMode) this.init();
      else new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
    }

    get shouldLock() { return true; }
    get testMode() { return this.getAttribute('data-test-mode') === 'true'; }
    get delay() { return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5; }
    get expiry() { return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30; }
    get cookieName() { return 'concept:newsletter-popup'; }

    // Explicit success marker: errors must never count as successful signups.
    get submited() { return this.querySelector('[data-newsletter-success]') !== null; }

    init() {
      if (this.initialized) return;
      this.initialized = true;
      const hasCookie = !!this.getCookie(this.cookieName);
      let submittedFlag = false;
      let pending = null;
      try {
        submittedFlag = sessionStorage.getItem('newsletter_submitted') === 'true';
        const stored = sessionStorage.getItem('sarkastic:newsletter-pending');
        if (stored) {
          const parsed = JSON.parse(stored);
          const age = Date.now() - parsed.time;
          // Allow time for a customer to complete a robot challenge.
          if (age >= 0 && age < 30 * 60 * 1000) pending = parsed;
          else sessionStorage.removeItem('sarkastic:newsletter-pending');
        }
      } catch (e) {}

      const submittedNow = this.submited;
      const popupForm = this.querySelector('form.newsletter-form');
      const popupSubmittedNow = submittedNow && pending && pending.popup === true &&
        popupForm && pending.formId === popupForm.id;
      const submitted = submittedFlag || submittedNow;
      const bar = document.querySelector('.newsletter-bar');
      if (bar) {
        if (submitted) bar.style.display = 'none';
        else if (hasCookie) bar.style.display = '';
        else bar.style.display = 'none';
      }

      if (submittedNow) {
        if (!this.testMode && !submittedFlag) {
          try { sessionStorage.setItem('newsletter_submitted', 'true'); } catch (e) {}
          if (!hasCookie) this.setCookie(this.cookieName, this.expiry);
        }
        // Only this popup's own successful submission may open its thank-you state.
        if (popupSubmittedNow && !submittedFlag) this.load(0.1);
        try { sessionStorage.removeItem('sarkastic:newsletter-pending'); } catch (e) {}
        return;
      }

      // Do not reopen an ordinary signup popup in a session that already subscribed.
      if (!this.testMode && submittedFlag) return;
      if (this.testMode || !hasCookie) this.load(this.delay);
    }

    load(delay) {
      if (Shopify.designMode) return;
      setTimeout(() => this.show(), delay * 1000);
    }
    afterShow() {
      super.afterShow();
      this.classList.add('show-image');
    }
    afterHide() {
      super.afterHide();
      this.classList.remove('show-image');
      const bar = document.querySelector('.newsletter-bar');
      let submittedFlag = false;
      try { submittedFlag = sessionStorage.getItem('newsletter_submitted') === 'true'; } catch (e) {}
      if (bar && !submittedFlag) bar.style.display = '';
      if (this.testMode) {
        this.removeCookie(this.cookieName);
        return;
      }
      this.setCookie(this.cookieName, this.expiry);
    }
    getCookie(name) {
      const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
      return match ? match[2] : null;
    }
    setCookie(name, expiry) {
      document.cookie = `${name}=true; max-age=${expiry * 24 * 60 * 60}; path=/`;
    }
    removeCookie(name) {
      document.cookie = `${name}=; max-age=0`;
    }
  });
}

